import { militaryToStandardTime } from '../../../../../shared/date-helpers';

const getScheduleDetails = ({
  start_date,
  num_weeks_estimate,
  start_time_estimate,
  end_time_estimate,
}) => {
  if (!start_date) return 'error';
  const date = new Date(start_date);
  const formattedDate = Intl.DateTimeFormat('default', { month: 'short', day: '2-digit' }).format(
    date
  );

  const start = militaryToStandardTime(start_time_estimate);
  const end = militaryToStandardTime(end_time_estimate);

  if (start_time_estimate && !end_time_estimate) {
    return `${formattedDate}  •  ${start}`;
  }

  return `${formattedDate}${
    num_weeks_estimate > 1 ? `  •  ${num_weeks_estimate} Weeks` : ''
  }  •  ${start} - ${end}`;
};

export default getScheduleDetails;
